import { CartActions, AirPFPurchaseActions } from "@hopper-b2b/checkout";
import { paymentActions } from "../../checkout/states/payments";

export const Actions = {
  ...AirPFPurchaseActions,
  ...CartActions,
  ...paymentActions,
};

type IActionTypes = {
  [K in keyof typeof Actions]: K;
};

export const ActionTypes: IActionTypes = Object.keys(Actions).reduce(
  (prev, cur) => ({ ...prev, [cur]: cur }),
  {} as IActionTypes
);
